<template>
  <a-textarea
    v-model:value="model"
    class="textarea-facade"
    :disabled="disabled"
    :id="id"
    :placeholder="placeholder"
    :maxlength="maxLength"
    :auto-size="{minRows: 5, maxRows: 20}"
    showCount
  />
</template>

<script setup>
  /**
   * Компонент-фасад для компонента <a-textarea/> из библиотеки ant-design-vue.
   * Его нужно использовать в коде компонентов вместо <a-textarea/>.
   * 
   * Пример использования:
   * <textarea-facade
   *   v-model="model.description"  
   *   id="description"  
   *   placeholder="Сформулируйте задачу *"
   *   :max-length="10000"
   * />
   */
  import { defineModel } from "vue";

  const model = defineModel();

  defineProps({
    // The ID for input
    id: {
      type: String,
      required: true,
    },

    // Whether the textarea is disabled.
    disabled: {
      type: Boolean,
      default: false,
    },

    // Текст подсказки, что нужно вводить в поле
    placeholder: {
      type: String,
      default: '',
    },

    // Максимальная длина текста, который можно ввести в поле
    maxLength: {
      type: Number,
      default: 1000,
    },
  });
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;

  .ant-input-textarea-show-count::after {
    color: $color-text-secondary-grey;
    font-family: Nunito Sans, sans-serif;
    font-size: 12px;
    font-weight: 400;
  }
</style>